import { useContext, useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingIndicator from '../../shared/components/LoadingIndicator';
import { SEGMENT_EVENTS } from '../../shared/Constants';
import { getCompany } from '../../shared/actions/index';
import { RuntimeContext } from '../../../common/RuntimeContext';

const DirectLink = (props) => {
    const config = useContext(RuntimeContext);
    const {
        match: {
            params: { companyId, collectionId }
        },
        history,
        location = {},
        getCompany,
        isVerbAdmin
    } = props;

    const [company, setCompany] = useState({});
    const stateParams = location.state || {};

    useEffect(() => {
        if (companyId) {
            getCompany({ companyId, pathsContext: config.pathsWeb })
                .then((company) => {
                    setCompany(company);
                })
                .catch((err) => {
                    console.log('DirectLink getCompanyError -> ', err);
                    history.replace({
                        pathname: `/collection/${collectionId}`,
                        state: stateParams
                    });
                });
        }
    }, []);

    useEffect(() => {
        if (Object.keys(company).length !== 0) {
            history.replace({
                pathname: `/collection/${collectionId}`,
                state: stateParams
            });
        }
    }, [company]);

    return (
        <div className={'directLinkPage'}>
            <LoadingIndicator />
        </div>
    );
};

DirectLink.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            companyId: PropTypes.string,
            collectionId: PropTypes.string
        })
    }),
    history: PropTypes.object,
    location: PropTypes.object,
    getCompany: PropTypes.func,
    isVerbAdmin: PropTypes.bool
};

const mapStateToProps = (state) => {
    const {
        auth: { isVerbAdmin }
    } = state;
    return {
        isVerbAdmin
    };
};

const mapDispatchToProps = (dispatch) => ({
    getCompany: (params) => dispatch(getCompany(params))
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(DirectLink);
